import { render, staticRenderFns } from "./JwFomResponseItem.vue?vue&type=template&id=ab3fc474&scoped=true"
import script from "./JwFomResponseItem.vue?vue&type=script&lang=js"
export * from "./JwFomResponseItem.vue?vue&type=script&lang=js"
import style0 from "./JwFomResponseItem.vue?vue&type=style&index=0&id=ab3fc474&prod&lang=scss"
import style1 from "./JwFomResponseItem.vue?vue&type=style&index=1&id=ab3fc474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3fc474",
  null
  
)

export default component.exports